import React from "react";
import { Sparkles } from "lucide-react";

// A phone frame showing the app's launch screen.
export const PhoneMockup = () => (
  <div className="relative mx-auto w-[260px] sm:w-[290px] fade-up" style={{ animationDelay: "160ms" }} data-testid="getapp-phone-mockup">
    <div className="absolute -inset-10 rounded-full bg-sky-300/40 blur-3xl" aria-hidden="true" />
    <div className="relative aspect-[9/19] rounded-[46px] bg-slate-900 p-[10px] shadow-[0_30px_80px_-20px_rgba(15,23,42,0.55)] ring-1 ring-slate-700">
      <div className="absolute top-[18px] left-1/2 -translate-x-1/2 w-24 h-6 rounded-full bg-black z-10" />
      <div className="relative h-full rounded-[36px] overflow-hidden bg-gradient-to-b from-[#0F172A] to-[#1E293B] flex flex-col items-center justify-center text-center px-6">
        <div className="absolute -bottom-24 left-1/2 -translate-x-1/2 w-72 h-72 rounded-full bg-sky-400/25 blur-3xl" />
        <img src="/icons/icon-192.png" alt="Ishukart app icon" className="relative w-20 h-20 rounded-[22px] shadow-[0_10px_30px_rgba(56,189,248,0.35)]" />
        <p className="relative mt-5 font-display text-2xl font-bold text-white tracking-tight">Ishukart</p>
        <p className="relative mt-1 text-xs text-slate-400">Build apps by chatting with AI</p>
        <div className="relative mt-8 w-full rounded-2xl bg-white/10 ring-1 ring-white/15 backdrop-blur-md p-3 text-left">
          <p className="text-[11px] text-slate-300 leading-relaxed">A booking page for my salon with WhatsApp reminders…</p>
          <div className="mt-2.5 flex justify-end">
            <span className="inline-flex items-center gap-1 h-6 px-2.5 rounded-full bg-sky-500 text-[10px] font-semibold text-white"><Sparkles size={10} /> Build</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default PhoneMockup;
